var r=(r,e,...t)=>{let a=Array.from(r);return a.splice(e,0,...t),a.join("")};export{r as default};